(function() {
    'use strict';

    angular.module('vobeApp').component('cardPackageSingleText', {
        templateUrl: 'app/components/vouchers/card/text/card-package-single-text.html',
        controller: 'CardPackageSingleController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            descriptionLines : '<',
            settings: '<',//like vm.settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openPackageModal: '<',//function
            websiteType: '<',//group or property
            groupCategories: '<',
            propertyCategories: '<',
            onlyFeatured: '<',
        }
    });
})();
